export default function init_utils(IconsView, iconsViewCache) {

    /**
     * Moteur de formatage de cellules pour la vue tableau
     * Inspiré et aligné sur Imagical\Form\Cell
     */
    IconsView.prototype.formatCellValue = function (val, column, data) {
        const myself = this;
        const format = column.format || column.type;

        // Si la valeur est indéfinie ou nulle (sauf pour les types spéciaux qui lisent data)
        const isValEmpty = (val === undefined || val === null || val === '');

        switch (format) {
        case 'id':
            return '<span class="cell--id mono bold nowrap">' + (isValEmpty ? '-' : String(val)) + '</span>';

        case 'money':
            if (isValEmpty) return '-';
            const numVal = parseFloat(val);
            if (isNaN(numVal)) return String(val);
            const formattedMoney = numVal.toLocaleString('fr-CA', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }) + '&nbsp;$';
            return '<span class="cell--money mono nowrap">' + formattedMoney + '</span>';

        case 'time':
            if (isValEmpty) return '-';
            const numTime = parseFloat(val);
            return '<span class="cell--time mono nowrap">' + (isNaN(numTime) ? String(val) : numTime + ' h') + '</span>';

        case 'percentage':
        case 'percent':
            if (isValEmpty) return '-';
            const numPct = parseFloat(val);
            if (isNaN(numPct)) return String(val);
            const minPct = (column.min !== undefined) ? parseFloat(column.min) : 0;
            const maxPct = (column.max !== undefined) ? parseFloat(column.max) : 100;
            const computedPct = (maxPct !== minPct) ? Math.round(((numPct - minPct) * 100) / (maxPct - minPct)) : Math.round(numPct);
            return '<span class="cell--percentage mono nowrap">' + computedPct + '&nbsp;%</span>';

        case 'boolean':
        case 'bool':
            const isTrue = (val === true || val === 1 || val === '1' || val === 'true');
            if (isTrue) {
                return '<span class="cell--boolean cell--boolean--true text-success" title="Oui"><i class="fa fa-check"></i></span>';
            }
            return '<span class="cell--boolean cell--boolean--false text-muted opacity-50" title="Non"><i class="fa fa-times"></i></span>';

        case 'date':
            if (isValEmpty) return '-';
            try {
                const dateVal = (val && typeof val === 'object' && val.date) ? val.date : val;
                const d = new Date(dateVal);
                if (isNaN(d.getTime())) return typeof val === 'object' ? '-' : String(val);
                return '<span class="cell--date nowrap">' + d.toLocaleDateString('fr-CA') + '</span>';
            } catch (e) {
                return typeof val === 'object' ? '-' : String(val);
            }

        case 'datetime':
            if (isValEmpty) return '-';
            try {
                const dtVal = (val && typeof val === 'object' && val.date) ? val.date : val;
                const dt = new Date(dtVal);
                if (isNaN(dt.getTime())) return typeof val === 'object' ? '-' : String(val);
                return '<span class="cell--datetime nowrap">' + dt.toLocaleDateString('fr-CA') + ' ' + dt.toLocaleTimeString('fr-CA', { hour: '2-digit', minute: '2-digit' }) + '</span>';
            } catch (e) {
                return typeof val === 'object' ? '-' : String(val);
            }

        case 'badge':
        case 'status':
            if (isValEmpty) return '-';
            let badgeLabel = String(val);
            let badgeCls = 'badge--default';
            let badgeIcon = '';

            if (column.options && column.options[val]) {
                const opt = column.options[val];
                if (typeof opt === 'string') {
                    badgeLabel = opt;
                } else if (Array.isArray(opt)) {
                    badgeLabel = opt[0] || badgeLabel;
                    badgeIcon = opt[1] ? myself.renderIconImage('small', opt[1]) + ' ' : '';
                    badgeCls = opt[2] || badgeCls;
                } else if (typeof opt === 'object') {
                    badgeLabel = opt.label || badgeLabel;
                    badgeCls = opt.class || opt.cls || badgeCls;
                    badgeIcon = opt.icon ? myself.renderIconImage('small', opt.icon) + ' ' : '';
                }
            }
            return '<span class="cell--badge badge ' + badgeCls + '">' + badgeIcon + badgeLabel + '</span>';

        case 'count':
            const countNum = (val !== undefined && val !== null && val !== '') ? parseInt(val, 10) : (data && data.count !== undefined ? data.count : 0);
            return '<span class="cell--count">' + (isNaN(countNum) ? '0' : countNum) + '</span>';

        case 'progress':
        case 'progressBar':
            const progVal = parseFloat(val) || 0;
            const progMin = (column.min !== undefined) ? parseFloat(column.min) : 0;
            const progMax = (column.max !== undefined) ? parseFloat(column.max) : 100;
            const progRatio = Math.min(100, Math.max(0, (progMax !== progMin) ? ((progVal - progMin) * 100) / (progMax - progMin) : progVal));
            return '<div class="cell--progress progress progress--full" style="height: 14px; min-width: 80px;" title="' + Math.round(progRatio) + '%">'
                 + '<div class="progress-bar" style="width: ' + progRatio + '%;"></div>'
                 + '</div>';

        case 'pie':
            const pieVal = parseFloat(val) || 0;
            const pieMin = (column.min !== undefined) ? parseFloat(column.min) : 0;
            const pieMax = (column.max !== undefined) ? parseFloat(column.max) : 100;
            const pieRatio = Math.min(100, Math.max(0, (pieMax !== pieMin) ? Math.round(((pieVal - pieMin) * 100) / (pieMax - pieMin)) : Math.round(pieVal)));
            return '<span class="cell--pie pie__chart animate" style="--p:' + pieRatio + ';" title="' + pieRatio + '%">'
                 + '<span class="pie__text">' + pieRatio + '</span>'
                 + '</span>';

        case 'avatar':
            const avatarUrl = (data && data.avatar) ? data.avatar : (typeof val === 'string' && val.indexOf('/') !== -1 ? val : '');
            const avatarName = (data && (data.name || data.label)) ? (data.name || data.label) : String(val || '');
            const avatarImg = avatarUrl ? '<span class="avatar__img" style="display:inline-block; vertical-align:middle; width:28px; height:28px; border-radius:50%; background:url(' + avatarUrl + ') center/cover no-repeat;"></span>'
                                        : '<span class="avatar__img avatar__img--placeholder" style="display:inline-block; vertical-align:middle; width:28px; height:28px; line-height:28px; text-align:center; border-radius:50%; background:#e0e0e0; font-weight:bold; font-size:12px;">' + (avatarName ? avatarName.charAt(0).toUpperCase() : '?') + '</span>';
            return '<span class="cell--avatar nowrap" style="display:inline-flex; align-items:center; gap:8px;">'
                 + avatarImg
                 + '<span class="avatar__name">' + avatarName + '</span>'
                 + '</span>';

        case 'filesize':
            if (isValEmpty) return '-';
            const fsNum = parseFloat(val);
            if (isNaN(fsNum)) return String(val);
            if (fsNum >= 1073741824) return '<span class="cell--filesize mono nowrap">' + (fsNum / 1073741824).toFixed(2) + '&nbsp;Go</span>';
            if (fsNum >= 1048576)    return '<span class="cell--filesize mono nowrap">' + (fsNum / 1048576).toFixed(1) + '&nbsp;Mo</span>';
            if (fsNum >= 1024)       return '<span class="cell--filesize mono nowrap">' + (fsNum / 1024).toFixed(0) + '&nbsp;Ko</span>';
            return '<span class="cell--filesize mono nowrap">' + fsNum + '&nbsp;o</span>';

        case 'number':
            if (isValEmpty) return '-';
            const numFormatVal = parseFloat(val);
            if (isNaN(numFormatVal)) return String(val);
            const formattedNum = numFormatVal % 1 === 0
                ? numFormatVal.toLocaleString('fr-CA')
                : numFormatVal.toLocaleString('fr-CA', { maximumFractionDigits: 2 });
            return '<span class="cell--number mono nowrap">' + formattedNum + '</span>';

        case 'ip':
            if (isValEmpty) return '-';
            return '<span class="cell--ip cell--mono mono">' + String(val) + '</span>';

        case 'mono':
            if (isValEmpty) return '-';
            const monoIpCls = (column && (column.name === 'ip' || (column.class && column.class.indexOf('ip') !== -1))) ? ' cell--ip' : '';
            return '<span class="cell--mono mono' + monoIpCls + '">' + String(val) + '</span>';

        case 'email':
            if (isValEmpty) return '-';
            return '<a class="cell--email" href="mailto:' + val + '"><i class="fa fa-envelope opacity-75"></i>&nbsp;' + val + '</a>';

        case 'mailto':
            if (isValEmpty) return '-';
            return '<a class="cell--mailto" href="mailto:' + val + '"><i class="fa fa-envelope opacity-75"></i> ' + val + '</a>';

        case 'tel':
            if (isValEmpty) return '-';
            return '<a class="cell--tel nowrap" href="tel:' + val + '"><i class="fa fa-phone opacity-75"></i> ' + val + '</a>';

        case 'link':
        case 'url':
            if (isValEmpty) return '-';
            const linkHref = (column.href) ? column.href.replace('{val}', val) : val;
            const linkTarget = column.target ? ' target="' + column.target + '"' : ' target="_blank"';
            return '<a class="cell--link" href="' + linkHref + '"' + linkTarget + '>' + val + '</a>';

        case 'spread':
            if (Array.isArray(val)) {
                const spreadItems = val.map(item => '<span class="cellspread tag" style="display:inline-block; padding:1px 6px; margin:1px; border-radius:3px; background:#f0f0f0; font-size:11px;">' + String(item) + '</span>');
                return '<span class="cell--spread">' + spreadItems.join('') + '</span>';
            }
            return isValEmpty ? '-' : String(val);

        case 'ellipsis':
            if (isValEmpty) return '-';
            return '<span class="cell--ellipsis ellipsis" style="max-width:' + (column.maxWidth || '200px') + '; display:inline-block; vertical-align:middle;" title="' + String(val).replace(/"/g, '&quot;') + '">' + val + '</span>';

        default:
            if (isValEmpty) return '&nbsp;';
            if (column.prefix || column.suffix) {
                return (column.prefix || '') + val + (column.suffix || '');
            }
            return String(val);
        }
    };

IconsView.prototype.findItem = function(id, type, data = null) {
        if (!data) data = this.data;
        for (const item of data) {
            if (!item) continue;
            const itemTypeStr = Array.isArray(item.type) ? item.type[0] : item.type;
            const targetTypeStr = Array.isArray(type) ? type[0] : type;
            if (item.id == id && itemTypeStr == targetTypeStr && !item.special) {
                return item;
            }
            if (item.childs && item.childs.length > 0) {
                const found = this.findItem(id, type, item.childs);
                if (found) return found;
            }
        }
        return null;
    };

IconsView.prototype.findItemById = function(id, data = null) {
        if (!data) data = this.data;
        for (const item of data) {
            if (!item) continue;
            if (item.id == id && !item.special) return item;
            if (item.childs && item.childs.length > 0) {
                const found = this.findItemById(id, item.childs);
                if (found) return found;
            }
        }
        return null;
    };


IconsView.prototype.getDateFields = function (type) {
        if (this.types && this.types[type] && this.types[type].date) {
            let dateConfig = this.types[type].date;
            if (typeof dateConfig === 'string') {
                return [dateConfig];
            } else if (Array.isArray(dateConfig)) {
                return dateConfig;
            }
        }
        return null;
    };


IconsView.prototype.submitDateChange = function (itemData, start, end) {
        const dateFields = this.getDateFields(itemData.type);

        const formatIsoLocal = (date) => {
            if (typeof date === 'string') return date;
            if (!date) return null;
            const pad = (n) => n < 10 ? '0' + n : n;
            return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate()) + ' ' +
                   pad(date.getHours()) + ':' + pad(date.getMinutes()) + ':' + pad(date.getSeconds());
        };

        if (dateFields) {
            const changes = {};
            changes[dateFields[0]] = start ? formatIsoLocal(start) : null;
            if (dateFields[1]) {
                changes[dateFields[1]] = end ? formatIsoLocal(end) : null;
            }
            this.submitChange(itemData, changes);
        }
    };




IconsView.prototype.findPath = function(id, type, data = null, path = []) {
        if (!data) data = this.data;
        
        for (const item of data) {
            // Vérifier si l'élément actuel correspond à l'ID (et au type si spécifié)
            const typeMatch = type === null || type === undefined || item.type === type;
            if (item.id === id && typeMatch) {
                // Retourner le chemin jusqu'à cet élément
                return [...path, { field: 'id', value: item.id, type: item.type }];
            }
            // Si l'élément actuel a des enfants, rechercher récursivement dans ses enfants
            if (item.childs && item.childs.length > 0) {
                const found = this.findPath(id, type, item.childs, [...path, { field: 'id', value: item.id, type: item.type }]);
                // Si on a trouvé le chemin dans les enfants, le retourner
                if (found) return found;
            }
        }
        // Si l'élément n'est pas trouvé, retourner null
        return null;
    };


IconsView.prototype.setPath = function (element, absolute) {
        if (this.request) this.request.abort();
        if (absolute) {
            this.path = Array.isArray(element) ? element : [];
        } else {
            // Switch view
            this.dataNodeParent = element;
            this.findTemplate(element);

            // update path
            this.path = [];
            while (true) {
                if (element && (element.id || element.label)) {
                    var pathNode;
                    pathNode = this.genPathNode(element);
                    this.path.unshift(pathNode);
                    element = element.parent;
                } else {
                    break;
                }
            }
        }
        setCookie(this.cookieName, JSON.stringify(this.path), 30);
    };


IconsView.prototype.genPathNode = function (element) {
        let pathNode;
        if (element.id) {
            pathNode = { field: 'id', value: element.id, type: element.type };
        } else {
            pathNode = { field: 'label', value: element.label, type: element.type };
        }
        return pathNode;
    }


IconsView.prototype.setIconSize = function (size, container, keep) {
        const myself = this;

        // Calendar, accordion and tree views don't need icon sizing
        if (this.view === 'accordion' || this.view === 'tree' || this.view === 'calendar' || this.view === 'calendar-week' || this.view === 'calendar-day') {
            return false;
        }

        const viewKey = this.templateName + ':' + this.view;

        if (this.dataNodeParent) {
            if (!this.dataNodeParent.iconSize) this.dataNodeParent.iconSize = {};
            if (!size) size = this.dataNodeParent.iconSize[this.view];
        }

        if (keep == 1) this.fixedSize[viewKey] = size;
        else if (keep == -1) this.fixedSize[viewKey] = null;
        else if (this.fixedSize[viewKey]) size = this.fixedSize[viewKey];

        if (!size) {
            size = this.fixedSize[viewKey] || this.viewThumbsWidth || this.getViewIconSize(this.view);
            this.fixedSize[viewKey] = size;
        }

        if (typeof size === 'string') {
            if (size === 'small') size = 24;
            else if (size === 'medium') size = (this.view === 'table' || this.view === 'list') ? 32 : 48;
            else if (size === 'large' || size === 'hd') size = 96;
            else if (!isNaN(size)) size = parseInt(size, 10);
        }

        if (!this.element.is(":visible")) {
            return false;
        }

        if (!container) container = this.element;

        let height = size;
        let width = size * this.viewThumbsProportions;

        const item = container.find('.iv__item').not('.iv__breadcrumb__item, .iv__tabs__btn');
        if (!item.length) return false;
        const itemImage = container.find('.iv__item__image').not('.iv__breadcrumb__item__image');
        const itemImageIco = container.find('.iv__item__image .ico').not('.iv__breadcrumb__item__image .ico');

        const scrollableOriginal = document.documentElement.scrollHeight > document.documentElement.clientHeight;
        const widthItemExtra = item.outerWidth() - item.width() + parseInt(item.css('marginRight').replace('px', ''));
        const widthViewport = Math.floor((this.element.find('.iv__tabs__pane > .iv__container:visible').length) ? this.element.find('.iv__tabs__pane > .iv__container:visible').width() : container.width()) - 1;
        let widthItemGoal = width * this.viewItemWidthRatio;
        if (widthItemGoal > this.viewItemWidthMax) widthItemGoal = this.viewItemWidthMax;
        if (widthItemGoal < this.viewItemWidthMin) widthItemGoal = this.viewItemWidthMin;
        const colsCountRaw = widthViewport / widthItemGoal;
        const colsCount = Math.floor(colsCountRaw);
        const widthFull = Math.floor((widthViewport / colsCount) - widthItemExtra);


        if (this.viewItemWidthRatio) {
            item.css('minWidth', widthFull + 'px');
            item.css('width', widthFull + 'px');
            if (this.viewItemWidthRatio == 1) {
                height = widthFull;
            }
            else {
                height = widthFull / this.viewItemWidthRatio;
            }
        }

        if (!myself.viewItemThumbsMode) {
            width = size;
            height = size;
        }

        itemImage.css('maxWidth', 100 + '%');
        itemImage.css('minWidth', width + 'px');
        itemImage.css('width', width + 'px');
        itemImage.css('height', height + 'px');

        item.removeClass('iv__item--size--' + item.data('size'));
        item.data('size', size);
        item.addClass('iv__item--size--' + item.data('size'));


        itemImageIco.removeClass((index, className) => (className.match(/(^|\s)ico--size--\S+/g) || []).join(' '));
        itemImageIco.data('size', size);
        itemImageIco.addClass('ico--size--' + item.data('size'));

        this.dataNodeParent.iconSize[this.view] = size;
        const scrollableNew = document.documentElement.scrollHeight > document.documentElement.clientHeight;

        if (scrollableOriginal != scrollableNew) {
            this.setIconSize(size, container, keep);
        }

        this.element.find('.iv__zoom').val(size);
    };


IconsView.prototype.findTemplate = function (dataNode) {
        const myself = this;
        let newTemplateName = this.templateName;
        this.template = null;
        if (dataNode.view) {
            this.template = dataNode.view;
            newTemplateName = 'bundled';
        } else if (dataNode.template && this.data && this.templates && this.templates[dataNode.template]) {
            this.template = this.templates[dataNode.template];
            newTemplateName = dataNode.template;
        } else if (this.data && this.templates && this.templates[this.options.template]) {
            this.template = this.templates[this.options.template];
            newTemplateName = this.options.template;
        }
        if (!this.template && this.templates) {
            newTemplateName = (this.options.template) ? this.options.template : Object.keys(this.templates)[0];
            if (typeof newTemplateName === 'object') newTemplateName = newTemplateName[0];
            this.template = this.templates[newTemplateName];
        }

        // use data template overide
        if (dataNode.templateSet) {
            mergeToObject(dataNode.templateSet, this.template);
        }

        // update view
        if ((!this.view || newTemplateName != this.templateName) && !this.viewLock) {
            if (this.fixedView[newTemplateName]) this.view = this.fixedView[newTemplateName];
            else if (this.template && this.template.view && this.template.view.default) { this.view = this.template.view.default; } else { this.view = 'mosaic'; }
        }
        this.templateName = newTemplateName;

        // auto sort
        if (this.fixedSort[this.templateName]) {
            myself.sort(this.fixedSort[this.templateName][0], null, this.fixedSort[this.templateName][1]);
        }
        else if (this.template && this.template.view && this.template.view.sort) {
            const defaultOrder = (this.template.view.order || this.template.order || 'asc').toLowerCase();
            myself.sort(this.template.view.sort, null, defaultOrder);
        }
    }


IconsView.prototype.loadPath = function (path, apply) {
        const myself = this;
        if (!path || !Array.isArray(path)) {
            path = Array.isArray(this.path) ? this.path : [];
        }

        // find to right place
        let dataNode = this.data;
        const pathValid = [];
        // loop in path node
        let node, data;
        for (const iPath in path) {
            node = path[iPath];
            if (!node) continue;

            let dataNodeDir = dataNode;
            if (dataNodeDir && dataNodeDir.childs) dataNodeDir = dataNodeDir.childs;
            // loop in data
            for (const iDataNode in dataNodeDir) {
                data = dataNodeDir[iDataNode];
                if (!data) continue;
                const dataDataType = Array.isArray(data.type) ? data.type[0] : data.type;
                const nodeType = Array.isArray(node.type) ? node.type[0] : node.type;

                if (data && data[node.field] == node.value && (!nodeType || dataDataType == nodeType) && !data.special) {
                    pathValid.push(node);
                    dataNode = data;
                    break;
                }
            }
        }

        if (apply) {
            this.pathValid = pathValid;
        }

        if (dataNode) {
            if (apply) {
                this.dataNode = dataNode.childs;
                this.dataNodeParent = dataNode;
                this.findTemplate(dataNode);
            } else {
                return dataNode;
            }
        }
    };


IconsView.prototype.applyQteClass = function (currentIcon) {
        const myself = this;
        var badge = currentIcon.find('.iv__item__badge');
        if (!badge.length || badge.hasClass('iv__item__badge--has-icon')) {
            return;
        }

        var badgeInput = currentIcon.find('.iv__item__badge__input');
        var badgeVal = badgeInput.length ? badgeInput.val() : currentIcon.find('.iv__item__badge__val').text();
        if (badgeVal === undefined || badgeVal === '') {
            badgeVal = badge.attr('data-val');
        }
        if (badgeVal === undefined || badgeVal === null || badgeVal === '' || isNaN(parseInt(badgeVal, 10))) {
            return;
        }
        badgeVal = parseInt(badgeVal, 10);

        currentIcon.removeClass(function(index, className) {
            return (className.match(/\biv__item--qte-\S+/g) || []).join(" ");
        });
        currentIcon.addClass('iv__item--qte-'+badgeVal);
        if (badgeVal == 0) {
            currentIcon.addClass('iv__item--qte-p0').addClass('inactive');
        }
        else {
            currentIcon.removeClass('inactive');
            currentIcon.addClass('iv__item--qte-p'+badgeVal.toString().length);
        }
    }


IconsView.prototype.resolveItemCount = function (itemData) {
        if (!itemData || itemData.special) return undefined;

        // Si count est explicitement null, on ne doit pas le résoudre ni compter les enfants
        if (itemData.count === null) {
            return null;
        }

        if (itemData.count !== undefined && itemData.count !== '') {
            const parsed = parseInt(itemData.count, 10);
            return isNaN(parsed) ? 0 : parsed;
        }

        if (itemData.childs && Array.isArray(itemData.childs)) {
            return itemData.childs.filter(c => c && !c.special).length;
        }

        return undefined;
    };


IconsView.prototype.getViewConfig = function (view) {
        const viewName = view || this.view;
        if (this.template && this.template.view) {
            const conf = this.template.view[viewName];
            if (conf !== undefined && conf !== null) return conf;
        }
        return {};
    };


IconsView.prototype.getViewIconSize = function (view) {
        const viewName = view || this.view;
        const viewConf = this.getViewConfig(viewName);

        // 1. Définition directe dans la configuration de la vue
        if (typeof viewConf === 'number' && viewConf > 0) return viewConf;
        if (typeof viewConf === 'string' && !isNaN(viewConf)) return parseInt(viewConf, 10);
        if (typeof viewConf === 'object' && viewConf !== null) {
            const s = viewConf.size ?? viewConf.iconSize;
            if (s !== undefined && s !== null) {
                if (typeof s === 'number' && s > 0) return s;
                if (typeof s === 'string') {
                    if (s === 'small') return 24;
                    if (s === 'medium') return (viewName === 'table' || viewName === 'list') ? 32 : 48;
                    if (s === 'large' || s === 'hd') return 96;
                    if (!isNaN(s)) return parseInt(s, 10);
                }
            }
        }

        // 2. Taille globale au niveau de template.view (template.view.size / template.view.iconSize)
        if (this.template && this.template.view) {
            const vSize = this.template.view.size ?? this.template.view.iconSize;
            if (vSize !== undefined && vSize !== null) {
                if (typeof vSize === 'number' && vSize > 0) return vSize;
                if (typeof vSize === 'string' && !isNaN(vSize)) return parseInt(vSize, 10);
            }
        }

        // 3. Taille au niveau du template (template.size / template.iconSize)
        if (this.template) {
            const tSize = this.template.size ?? this.template.iconSize;
            if (tSize !== undefined && tSize !== null) {
                if (typeof tSize === 'number' && tSize > 0) return tSize;
                if (typeof tSize === 'string' && !isNaN(tSize)) return parseInt(tSize, 10);
            }
        }

        // 4. Tailles par défaut canoniques par mode de vue
        switch (viewName) {
            case 'icons':
                return 96;
            case 'mosaic':
            case 'preview':
                return 64;
            case 'summary':
                return 112;
            case 'cards':
                return 128;
            case 'thumbnails':
                return 128;
            case 'slideshow':
                return 128;
            case 'list':
            case 'table':
            case 'tree':
            case 'blocks':
            case 'calendar':
            case 'calendar-week':
            case 'calendar-day':
            default:
                return 24;
        }
    };


IconsView.prototype.normalizeShape = function (shape) {
        if (!shape || typeof shape !== 'string') return 'default';
        const s = shape.toLowerCase().trim();
        if (s === 'scare' || s === 'square') return 'scare';
        if (s === 'circle') return 'circle';
        if (s === 'rectangle') return 'rectangle';
        return s || 'default';
    };


IconsView.prototype.getItemShape = function (data, view) {
        const viewName = view || this.view;

        // 1. Sur une entrée de donnée
        if (data) {
            const itemShape = data.shape ?? (data.data && data.data.shape);
            if (itemShape !== undefined && itemShape !== null && itemShape !== '') {
                return this.normalizeShape(itemShape);
            }
        }

        // 2. Options d'une vue d'un template (concerne que la vue en question)
        const viewConf = typeof this.getViewConfig === 'function' ? this.getViewConfig(viewName) : null;
        if (viewConf && typeof viewConf === 'object' && viewConf.shape !== undefined && viewConf.shape !== null && viewConf.shape !== '') {
            return this.normalizeShape(viewConf.shape);
        }

        // 3. Option globale de vue d'un template (template.view.shape)
        if (this.template && this.template.view && this.template.view.shape !== undefined && this.template.view.shape !== null && this.template.view.shape !== '') {
            return this.normalizeShape(this.template.view.shape);
        }

        // 4. Mis sur un template (template.shape), s'applique globalement si template actif
        if (this.template && this.template.shape !== undefined && this.template.shape !== null && this.template.shape !== '') {
            return this.normalizeShape(this.template.shape);
        }

        // 5. Options d'IconsView
        if (this.options && this.options.shape !== undefined && this.options.shape !== null && this.options.shape !== '') {
            return this.normalizeShape(this.options.shape);
        }

        // 6. Comportement par défaut actuel
        return 'default';
    };


IconsView.prototype.normalizeColumn = function (col) {
        if (typeof col === 'object' && col !== null) {
            if (!col.type && col.name) {
                col.type = 'data';
            }
            return col;
        }

        if (typeof col !== 'string') {
            return col;
        }

        col = col.trim();
        if (!col) return { type: 'data', name: '', label: '' };

        const standardActions = ['open', 'edit', 'delete', 'clone', 'add', 'enable', 'disable', 'activation'];
        if (standardActions.includes(col)) {
            return { type: 'action', name: col };
        }

        if (col.startsWith(':')) {
            return { type: 'action', name: col.slice(1) };
        }

        const parts = col.split(':');
        const first = parts[0];

        if (first === 'icon') {
            const res = { type: 'icon', label: '' };
            if (parts[1]) {
                res.size = isNaN(parts[1]) ? parts[1] : parseInt(parts[1], 10);
            }
            return res;
        }

        if (first === 'label') {
            const label = parts[1] || 'Nom';
            const res = { type: 'label', label: label };
            if (parts[2]) {
                res.size = isNaN(parts[2]) ? parts[2] : parseInt(parts[2], 10);
            }
            return res;
        }

        if (first === 'action' && parts[1]) {
            return { type: 'action', name: parts[1] };
        }

        if (first === 'actions' && parts[1]) {
            const actionList = parts[1].split(',').map(s => s.trim()).filter(Boolean);
            const label = (parts[2] && isNaN(parts[2])) ? parts[2] : 'Actions';
            let size = null;
            if (parts[2] && !isNaN(parts[2])) {
                size = parseInt(parts[2], 10);
            } else if (parts[3]) {
                size = isNaN(parts[3]) ? parts[3] : parseInt(parts[3], 10);
            }
            const res = {
                type: 'actions',
                actions: actionList,
                label: label,
                align: 'right',
            };
            if (size !== null) res.size = size;
            return res;
        }

        const typedFormats = {
            'date': { format: 'date' },
            'datetime': { format: 'datetime' },
            'money': { format: 'money', align: 'right' },
            'bool': { format: 'boolean', align: 'center' },
            'boolean': { format: 'boolean', align: 'center' },
            'count': { format: 'count', align: 'center' },
            'badge': { format: 'badge', align: 'center' },
            'status': { format: 'badge', align: 'center' },
            'number': { format: 'number', align: 'center' },
            'input': { type: 'input' },
            'section': { type: 'section' },
        };

        const formatName = (str) => {
            const s = str.replace(/_/g, ' ');
            return s.charAt(0).toUpperCase() + s.slice(1);
        };

        if (typedFormats[first] && parts[1]) {
            const name = parts[1];
            const conf = typedFormats[first];
            const type = conf.type || 'data';
            let label = null;
            let size = null;

            if (parts[2]) {
                if (!isNaN(parts[2])) {
                    size = parseInt(parts[2], 10);
                } else {
                    label = parts[2];
                }
            }
            if (parts[3]) {
                size = isNaN(parts[3]) ? parts[3] : parseInt(parts[3], 10);
            }

            if (label === null) {
                label = formatName(name);
            }

            const res = { type: type, name: name, label: label };
            if (conf.format) res.format = conf.format;
            if (conf.align) res.align = conf.align;
            if (size !== null) res.size = size;
            return res;
        }

        // Default data column
        const name = first;
        let label = null;
        let size = null;

        if (parts[1]) {
            if (!isNaN(parts[1])) {
                size = parseInt(parts[1], 10);
            } else {
                label = parts[1];
            }
        }
        if (parts[2]) {
            size = isNaN(parts[2]) ? parts[2] : parseInt(parts[2], 10);
        }

        if (label === null) {
            label = formatName(name);
        }

        const res = { type: 'data', name: name, label: label };
        if (size !== null) res.size = size;
        return res;
    };


IconsView.prototype.getViewColumns = function (view) {
        const myself = this;
        const viewName = view || this.view;
        const conf = this.getViewConfig(viewName);
        let cols = [];
        if (Array.isArray(conf)) {
            cols = conf;
        } else if (typeof conf === 'object' && conf !== null) {
            if (Array.isArray(conf.columns)) cols = conf.columns;
            else if (Array.isArray(conf.cols)) cols = conf.cols;
            else if (Array.isArray(conf.table)) cols = conf.table;
        }
        return cols.map(c => myself.normalizeColumn(c));
    };


IconsView.prototype.getViewFields = function (view) {
        const viewName = view || this.view;
        const conf = this.getViewConfig(viewName);
        if (Array.isArray(conf)) return conf;
        if (typeof conf === 'object' && conf !== null) {
            if (Array.isArray(conf.fields)) return conf.fields;
            if (Array.isArray(conf.subtext)) return conf.subtext;
            if (Array.isArray(conf.add)) return conf.add;
        }
        // Fallback: pour tree/blocks/calendar/preview, repli sur mosaic.fields
        if (viewName !== 'mosaic') {
            const mosaicConf = this.getViewConfig('mosaic');
            if (Array.isArray(mosaicConf)) return mosaicConf;
            if (typeof mosaicConf === 'object' && mosaicConf !== null && Array.isArray(mosaicConf.fields)) {
                return mosaicConf.fields;
            }
        }
        return [];
    };


IconsView.prototype.getViewActions = function (view) {
        const viewName = view || this.view;
        const conf = this.getViewConfig(viewName);
        if (Array.isArray(conf)) {
            return conf.filter(item => item && (item.type === 'action' || item.name));
        }
        if (typeof conf === 'object' && conf !== null && Array.isArray(conf.actions)) {
            return conf.actions;
        }
        return [];
    };


IconsView.prototype.shouldShowCount = function (data, view) {
        if (!data || data.special) return false;
        if (data.count === undefined || data.count === null) return false;

        const viewName = view || this.view;

        // 1. Data level override
        if (data.showCount !== undefined) {
            if (typeof data.showCount === 'boolean') return data.showCount;
            if (typeof data.showCount === 'string') return data.showCount === viewName || data.showCount === 'all';
            if (Array.isArray(data.showCount)) return data.showCount.includes(viewName);
        }
        if (data.countView) {
            if (Array.isArray(data.countView)) return data.countView.includes(viewName);
            if (typeof data.countView === 'string') return data.countView === viewName || data.countView === 'all';
        }

        // 2. Template per-view config
        if (this.template && this.template.view) {
            const viewConf = this.template.view[viewName];
            if (viewConf && typeof viewConf === 'object' && viewConf.count !== undefined) {
                if (typeof viewConf.count === 'boolean') return viewConf.count;
                if (typeof viewConf.count === 'string') return viewConf.count === viewName;
            }

            // 3. Template view.count general config
            const tmplViewCount = this.template.view.count;
            if (tmplViewCount !== undefined) {
                if (typeof tmplViewCount === 'boolean') return tmplViewCount;
                if (typeof tmplViewCount === 'string') {
                    if (tmplViewCount === 'badge') return viewName === 'badge';
                    return tmplViewCount === viewName || tmplViewCount === 'all';
                }
                if (Array.isArray(tmplViewCount)) return tmplViewCount.includes(viewName);
            }
        }

        // 4. Template level
        if (this.template && this.template.count !== undefined) {
            if (typeof this.template.count === 'boolean') return this.template.count;
            if (typeof this.template.count === 'string') {
                if (this.template.count === 'badge') return viewName === 'badge';
                return this.template.count === viewName || this.template.count === 'all';
            }
            if (Array.isArray(this.template.count)) return this.template.count.includes(viewName);
        }

        // 5. Options level
        if (this.options && this.options.count !== undefined) {
            if (typeof this.options.count === 'boolean') return this.options.count;
            if (typeof this.options.count === 'string') {
                if (this.options.count === 'badge') return viewName === 'badge';
                return this.options.count === viewName || this.options.count === 'all';
            }
            if (Array.isArray(this.options.count)) return this.options.count.includes(viewName);
        }

        return false;
    };


IconsView.prototype.shouldShowCountBadge = function (data) {
        if (!data || data.special) return false;
        if (data.badge) return true;
        if (data.count === undefined || data.count === null) return false;

        if (data.showCount === 'badge' || data.countBadge === true) return true;
        if (data.countView && (data.countView === 'badge' || (Array.isArray(data.countView) && data.countView.includes('badge')))) return true;
        if (this.shouldShowCount(data, 'badge')) return true;

        if (this.template && (this.template.badge === true || (this.template.view && this.template.view.badge === true))) return true;
        if (this.options && this.options.badge === true) return true;

        return false;
    };


IconsView.prototype.remapData = function (data) {
        if (!data.special) {
            $.each(this.options.remap, (targetKey, remapRule) => {
                if (!remapRule) return;

                // Cas 1: Tableau de champs alternatifs / prioritaires [ex: ['title', 'src', 'name']]
                // ou chemin unique sous forme de tableau ou de chaîne de caractères
                let candidates = [];
                if (Array.isArray(remapRule)) {
                    candidates = remapRule;
                } else if (typeof remapRule === 'string') {
                    candidates = [remapRule];
                }

                for (let i = 0; i < candidates.length; i++) {
                    let candidate = candidates[i];
                    let val = undefined;

                    if (typeof candidate === 'string') {
                        if (candidate.indexOf('.') > -1) {
                            // Support de chemin imbriqué (a.b.c)
                            let parts = candidate.split('.');
                            let cur = data;
                            for (let p of parts) {
                                if (cur && cur[p] !== undefined) {
                                    cur = cur[p];
                                } else {
                                    cur = undefined;
                                    break;
                                }
                            }
                            val = cur;
                        } else {
                            val = data[candidate];
                        }

                        if (val !== undefined && val !== null && val !== '') {
                            if (data[candidate + '-type'] === 'imagePicker') {
                                val = 'img-' + val;
                            }
                            data[targetKey] = val;
                            break; // Valeur trouvée, on s'arrête au premier candidat valide
                        }
                    }
                }
            });
        }
        return data;
    }


IconsView.prototype.findSelectionFromIcon = function (icon) {
        const data = icon.data('data');
        const { id } = data;
        const { type } = data;
        let result = false;
        $.each(this.selection, (key, selectionItem) => {
            if (selectionItem.id == id && selectionItem.type == type) {
                result = key;
            }
        });
        return result;
    }


IconsView.prototype.removeSelectionFromIcon = function (icon) {
        const selection = this.findSelectionFromIcon(icon);
        if (selection !== false) {
            this.selection = arrayRemove(this.selection, selection);
        }
    }


IconsView.prototype.addSelectionFromIcon = function (icon) {
        const selection = this.findSelectionFromIcon(icon);
        if (selection === false) {
            this.selection.push({
                id: icon.data('id'),
                type: icon.data('type'),
                data: icon.data('data'),
                el: icon,
            });
        }
    }


IconsView.prototype.changeSelection = function (lastSelected) {
        const myself = this;
        if (lastSelected) this.selectionLast = lastSelected;

        let grid = this.element;
        if (!$(grid).hasClass('iconGrid')) {
            grid = $(grid).closest('.iconGrid');
        }
        const selected = grid.find('.iv__item--selected');
        const buttonRestricted = grid.find('.iv__toolbar button.require-selection');
        if (selected.length > 0) {
            buttonRestricted.removeAttr('disabled');
        } else {
            buttonRestricted.attr('disabled', 'disabled');
        }

        // change selection value
        if (this.selectionInput) {
            let selectionValue = '';
            let selectionType = '';
            let selectionLabel = '';

            if (this.selection.length > 0) {
                for (let i = 0; i < this.selection.length; i++) {
                    selectionValue = (this.selection[i].id);
                    selectionType = (this.selection[i].type);
                    selectionLabel = ((this.selection[i].data) ? this.selection[i].data.label : '');
                }
            }

            this.selectionInput.val(selectionValue);
            this.selectionInputType.val(selectionType);
            this.selectionInputLabel.val(selectionLabel);

            this.element.val(selectionValue);
            this.element.data('type', selectionType);
            this.element.data('label', selectionLabel);

            this.selectionInput.change();
            this.selectionInputType.change();
            this.selectionInputLabel.change();
        }

        this.updateTableBadgeColumnVisibility();

        this.updatePreviewPane(lastSelected);

        if (myself.events.change) myself.events.change(myself.selection, myself);
        myself.element.trigger('iv:change', [myself.selection, myself]);
        myself.element.trigger('iconsview:change', [myself.selection, myself]);
        myself.element.change();
    };


IconsView.prototype.updateTableBadgeColumnVisibility = function () {
        if (this.view !== 'table') return;

        let grid = this.element;
        if (!$(grid).hasClass('iconGrid')) {
            grid = $(grid).closest('.iconGrid');
        }

        const container = grid.find('.iv__container');
        if (!container.length) return;

        // Check if any badge is present or any item is selected
        const hasBadges = container.find('.iv__item__col-badge .iv__item__badge').length > 0;
        const hasSelected = container.find('.iv__item--selected').length > 0;

        if (hasBadges || hasSelected) {
            container.addClass('iv__container--has-badges');
        } else {
            container.removeClass('iv__container--has-badges');
        }
    };


IconsView.prototype.preloadPreviewPane = function () {
        const myself = this;
        myself.preview.html('');
        let slider = $('<div class="iv__preview__slides slick"></div>');
        myself.preview.append(slider);
        let i = 0;
        $.each(myself.dataNode, function() {
            if (this.html) {
                let slide = '<div class="iv__preview__slide">'+this.html+'</div>';
                slider.append(slide);
                this.sliderIndex = i;
                i++;
            }
        })
    }


IconsView.prototype.updatePreviewPane = function (lastSelected) {
        const myself = this;
        const previewPane = this.element.find('.iv__preview:visible');
        if (previewPane && previewPane.find('.iv__preview__slide') && false) {

        }
        else if (previewPane) {
            lastSelected = $(lastSelected);
            previewPane.removeClass('iv__preview--loading');
            previewPane.removeClass('iv__preview--ajax');
            previewPane.removeClass('iv__preview--iframe');
            previewPane.removeClass('iv__preview--html');
            previewPane.removeClass('iv__preview--image');
            previewPane.removeClass('iv__preview--icon');
            previewPane.removeClass('iv__preview--msg');
            const data = lastSelected.data('data');
            myself.onUnload(previewPane);
            if (data) {
                if (data.url) {
                    if (this.template && this.template.view && this.template.view.preview.mode == 'ajax') {
                        previewPane.html('');
                        previewPane.addClass('iv__preview--loading');

                        ajaxForm({
                            url: data.url + '?output=text',
                            method: 'GET',
                            dataType: 'html',
                            callback(data, form) {
                                myself.onUnload(previewPane);
                                previewPane.html(data);
                                myself.onOnload(previewPane);
                                previewPane.addClass('iv__preview--ajax');
                                previewPane.removeClass('iv__preview--loading');
                            },
                        });
                    } else {
                        previewPane.html('<iframe src="' + data.url + '"></iframe>');
                        previewPane.addClass('iv__preview--iframe');
                    }
                } else if (data.html) {
                    previewPane.html(data.html);
                    previewPane.addClass('iv__preview--html');
                } else if (data.file) {
                    switch (fileExtention(data.file.toLowerCase())) {
                    case 'jpg':
                    case 'jpeg':
                    case 'png':
                    case 'gif':
                    case 'bmp':
                    case 'ico':
                    case 'svg':
                        previewPane.html('<div>' + iconImg(data.file) + '</div>');
                        previewPane.addClass('iv__preview--image');
                        break;
                    default:
                        previewPane.html('<div>Format Incompatible</div>');
                        previewPane.addClass('iv__preview--msg');
                        break;
                    }
                } else {
                    previewPane.addClass('iv__preview--icon');
                    previewPane.html('<div>' + this.renderIconImage('hd', data.icon, data) + '</div>');
                }
            } else {
                previewPane.addClass('iv__preview--msg');
                previewPane.html('<div>Choisir un élément...</div>');
            }
        }
    }


IconsView.prototype.val = function () {
        return this.selection;
    };


IconsView.prototype.scroll = function () {
        const myself = this;
        if (myself.options && (myself.options.scroll === false || myself.options.noScroll || myself.options.autoScroll === false)) {
            return;
        }
        if (this.element.closest('.devguide-root, .devguide-layout, .devguide-preview-iconview-wrapper, .window__content, [data-no-scroll="true"]').length) {
            return;
        }
        if (!this.element.closest('.window__frame').length) {
            $(window).scrollTop(this.scrollLast);
            const windowTop = $(window).scrollTop();
            if (myself.element.is(':visible') && myself.element.offset()) {
                const elTop = myself.element.offset().top;
                if (windowTop > 0 && windowTop < elTop) {
                    $.scrollTo(elTop, 200);
                }
            }
        }
    };


IconsView.prototype.restoreFilter = function () {
        const myself = this;
        $.each(myself.filters, (filterField, filter) => {
            myself.element.find('.filter.' + filterField).filter('input, select, textarea').val(filter.value);
        });

        myself.applyFilter(false);
    }


IconsView.prototype.applyFilter = function (noApply, filters) {
        const myself = this;
        this.filters = {};

        // Default template.view.filters if defined
        if (this.template && this.template.view && this.template.view.filters && typeof this.template.view.filters === 'object') {
            $.each(this.template.view.filters, (field, conf) => {
                const isObj = (typeof conf === 'object' && conf !== null);
                myself.filters[field] = {
                    value: isObj ? (conf.value !== undefined ? conf.value : null) : conf,
                    queryNull: isObj ? !!conf.queryNull : false,
                    keepNull: isObj ? !!conf.keepNull : false,
                    like: isObj ? !!conf.like : false,
                };
            });
        }

        if (!filters) filters = this.element.add(this.element.parent().parent().parent().find('.iv__toolhook'))

        filters.find('.filter').filter('input, select, textarea').each(function () {
            myself.filters[$(this).data('field')] = {
                value: $(this).val(),
                queryNull: $(this).data('queryNull'),
                keepNull: $(this).data('keepNull'),
                like: $(this).data('like'),
            };
        });

        if (noApply !== false) {
            this.renderIconsAreas();

            if (myself.reloadInput) {
                if (myself.events.refreshInput) myself.events.refreshInput(myself.element);
            }
        }
    }


IconsView.prototype.filter = function (icon) {
        const myself = this;
        if (!icon.special) {
            // Global text search query if defined
            if (myself.searchQuery) {
                const q = myself.searchQuery.toLowerCase();
                let matched = false;
                if (icon.label && String(icon.label).toLowerCase().indexOf(q) !== -1) {
                    matched = true;
                } else if (icon.title && String(icon.title).toLowerCase().indexOf(q) !== -1) {
                    matched = true;
                } else if (icon.data && typeof icon.data === 'object') {
                    for (const k in icon.data) {
                        const v = icon.data[k];
                        if (v !== null && v !== undefined && String(v).toLowerCase().indexOf(q) !== -1) {
                            matched = true;
                            break;
                        }
                    }
                }
                if (!matched) return false;
            }

            let state = true;
            $.each(myself.filters, (filterField, filter) => {
                const currentVal = (icon.data && icon.data[filterField] !== undefined) ? icon.data[filterField] : (icon[filterField] !== undefined ? icon[filterField] : '');
                if (filter.queryNull || (filter.value !== null && filter.value !== undefined && filter.value !== '')) {
                    if (filter.value === '') filter.value = null;
                    if (currentVal != filter.value && !(filter.keepNull && !currentVal)) {
                        if (!filter.like) {
                            state = false;
                        } else {
                            const valStr = (currentVal !== null && currentVal !== undefined) ? String(currentVal).toLowerCase() : '';
                            const queryStr = String(filter.value).toLowerCase();
                            if (valStr.indexOf(queryStr) === -1) {
                                state = false;
                            }
                        }
                    }
                }
            });
            return state;
        }
        return true;
    }


IconsView.prototype.search = function (query) {
        this.searchQuery = query ? String(query).trim() : '';
        this.renderIconsAreas();
    };


IconsView.prototype.sort = function (order, type, side) {
        if (order) {
            if (side) {
                if (side.toLowerCase == 'desc') {
                    this.order = order + '-desc';
                } else {
                    this.order = order;
                }
            }
            else {
                if (this.order == order) {
                    this.order = order + '-desc';
                } else {
                    this.order = order;
                }
            }
        }
        this.orderType = type;
        if (order) this.fixedSort[this.templateName] = [order, side];
        if (this.order) {
            order = this.order.split('-');
            this.element.find('th[data-sort]').removeClass('sorted');
            this.element.find('th[data-sort]').removeClass('sorted-desc');
            this.element.find('th[data-sort=' + order[0] + ']').addClass('sorted' + ((order[1] == 'desc') ? '-desc' : ''));

            /*
             this.element.find('.item-container').each(function() {
             $(this).find('> .iv__item, tbody > .iv__item').sort(this.sortFunction).appendTo($(this));
             });
             */
            const currentContainer = this.element.find('.iv__container');
            for (let i = 0; i < currentContainer.length; i++) {
                $(currentContainer[i]).find('> .iv__item, tbody > .iv__item').sort(this.sortFunction).appendTo(currentContainer[i]);
            }

            // this.element.find('.iv__container').find('> .iv__item, tbody > .iv__item').sort(this.sortFunction).appendTo(this.container);
            // .sort(function(a, b) {if (!$(a).data('sticky')) $(a).data('sticky', 0); if (!$(b).data('sticky')) $(b).data('sticky', 0); console.log(parseFloat($(a).data('sticky'))); return parseFloat($(a).data('sticky')) < parseFloat($(b).data('sticky'));})
        }
    };


IconsView.prototype.sortFunction = function (a, b) {
        const myself = $(a).closest('.iconGrid').data('plugin');
        let { orderType } = myself;
        const order = myself.order ? myself.order.split('-') : ['name', 'asc'];

        a = $(a);
        b = $(b);

        // sticky compare
        let dataA = (a.data('sticky')) ? a.data('sticky') : 0;
        let dataB = (b.data('sticky')) ? b.data('sticky') : 0;
        if (dataA != dataB) {
            let $sticky = sortCompare(dataB, dataA, 'number');
            if ($sticky !== 0) {
                return $sticky;
            }
        }

        const isFolderA = a.hasClass('iv__item--type-folder') || a.data('type') === 'folder' || (Array.isArray(a.data('type')) && a.data('type').includes('folder')) || (a.data('data') && a.data('data').type === 'folder');
        const isFolderB = b.hasClass('iv__item--type-folder') || b.data('type') === 'folder' || (Array.isArray(b.data('type')) && b.data('type').includes('folder')) || (b.data('data') && b.data('data').type === 'folder');

        if (isFolderA && !isFolderB) return -1;
        if (!isFolderA && isFolderB) return 1;

        if (order[1] == 'desc') {
            const c = a;
            a = $(b);
            b = $(c);
        }

        switch (order[0]) {
        case 'name':
        case 'label':
            return sortCompare(
                (a.data('label') || '').toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
                (b.data('label') || '').toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
            );
        default:
            dataA = String(a.data(order[0]));
            if (dataA == 'undefined' && a.data('data') && (a.data('data').data)) dataA = String(a.data('data').data[order[0]])
            if (dataA != 'undefined') dataA = dataA.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            else dataA = '';

            dataB = String(b.data(order[0]));
            if (dataB == 'undefined' && b.data('data') && (b.data('data').data)) dataB = String(b.data('data').data[order[0]])
            if (dataB != 'undefined') dataB = dataB.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            else dataB = '';

            if (dataA > 0 && dataB > 0) orderType = 'number';

            switch (orderType) {
            case 'number':
            case 'int':
                return sortCompare(dataA, dataB, 'number');
            default:
                return sortCompare(dataA, dataB);
            }
        }
    };


IconsView.prototype.submitOrder = function () {
        const myself = this;
        if (this.options.features.sortable) {
            const datas = {};
            const items = this.element.find('.iv__item').not('.iv__breadcrumb__item, .iv__item--special-parent');

            // Field mode
            if (this.dataMode == 'field') {
                const newNodes = [];
                const dataClean = [];
                $.each(this.dataNode, function () {
                    if (this.special) newNodes.push(this);
                });

                for (var i = 0; i < items.length; i++) {
                    var item = $(items[i]);
                    const itemData = item.data('data');
                    newNodes.push(itemData);
                    if (itemData && itemData.dataClean) {
                        dataClean.push(itemData.dataClean);
                    }
                }
                this.dataNode = newNodes;
                this.dataClean = dataClean;

                this.save();
            }
            // Normal
            else {
                for (var i = 0; i < items.length; i++) {
                    var item = $(items[i]);
                    const { field } = this.options.features.sortable;
                    if (item.data('id') && !item.data('data').special) {
                        const type = item.data('type');
                        const currentData = { id: item.data('id') };
                        currentData[field] = i;

                        // append
                        if (!datas[type]) datas[type] = [];
                        datas[type].push(currentData);
                    }
                }

                // each types order array
                $.each(datas, (type, data) => {
                    let { request } = myself.options.features.sortable;
                    if (myself.options.api && myself.options.api[type]) request = myself.options.api[type];

                    ajaxForm({
                        url: request,
                        method: 'POST',
                        data,
                    });
                });
            }
        }
    };


IconsView.prototype.submitParent = function (items, newParent, dropProperties) {
        if (!dropProperties) return;

        const myself = this;
        const data = [];
        let field = dropProperties.field;
        let request = dropProperties.request;

        // Resolve target parent information
        const newParentRawData = newParent.data('data');
        let resolvedNewParentId;
        let newParentTypeStr;

        if (newParentRawData && newParentRawData.special === 'parent') {
            // Special 'parent' back button: target container ID is stored directly on element data('id')
            resolvedNewParentId = newParent.data('id') || (newParentRawData.id !== undefined ? newParentRawData.id : (myself.rootId || null));
            const newParentType = newParent.data('type') || newParentRawData.type;
            newParentTypeStr = Array.isArray(newParentType) ? newParentType[0] : (newParentType || myself.rootType || 'character');
        } else {
            // Regular item, breadcrumb, or tab: target is the element itself
            resolvedNewParentId = newParent.data('id');
            const newParentType = newParent.data('type');
            newParentTypeStr = Array.isArray(newParentType) ? newParentType[0] : newParentType;
        }

        const isRootTarget = (resolvedNewParentId === null || resolvedNewParentId === undefined || resolvedNewParentId == myself.rootId || newParentTypeStr === 'character' || newParentTypeStr === myself.rootType || newParentTypeStr === 'root');

        // Collect items and snapshot their DOM references BEFORE any removal
        const itemSnapshots = [];
        $.each(items, (index, item) => {
            item = $(item);
            let type = item.data('type');
            if (typeof type === 'object') type = type[0];

            if (type) {
                let currentData = {};
                if (dropProperties.data) currentData = Object.assign({}, dropProperties.data);

                if (dropProperties.accept && dropProperties.accept[type] instanceof Object) {
                    if (dropProperties.accept[type].field)   field   = dropProperties.accept[type].field;
                    if (dropProperties.accept[type].request) request = dropProperties.accept[type].request;
                    if (dropProperties.accept[type].data) currentData = Object.assign(currentData, dropProperties.accept[type].data);
                }
                else if (item.data('ref') && item.data('ref') == newParent.data('ref')) {
                    type = 'ref';
                    if (dropProperties.accept[type].field)   field   = dropProperties.accept[type].field;
                    if (dropProperties.accept[type].request) request = dropProperties.accept[type].request;
                    if (dropProperties.accept[type].data) currentData = Object.assign(currentData, dropProperties.accept[type].data);
                }

                if (myself.options.api && myself.options.api[type]) { request = myself.options.api[type]; }

                const accepted = dropProperties.accept
                    ? (dropProperties.accept[type] || (Array.isArray(dropProperties.accept) && dropProperties.accept.includes(type)))
                    : false;

                const itemData = item.data('data');
                const parentObj = itemData ? itemData.parent : null;

                // Check if item is ALREADY in target container (no-op drop)
                let isSameContainer = false;
                if (parentObj) {
                    if (isRootTarget) {
                        isSameContainer = (parentObj.id == myself.rootId || parentObj.type === 'root' || parentObj.id === null || parentObj.id === undefined);
                    } else {
                        isSameContainer = (parentObj.id !== undefined && parentObj.id !== null && parentObj.id == resolvedNewParentId);
                    }
                }

                if (accepted && item.data('id') != resolvedNewParentId && !isSameContainer) {
                    currentData.id = item.data('id');
                    currentData[field] = resolvedNewParentId;
                    data.push(Object.assign({}, currentData));

                    const ivItem = item.hasClass('iv__item') ? item : item.closest('.iv__item');
                    itemSnapshots.push({ item, ivItem, itemData });
                }
            }
        });

        if (data.length === 0) return;

        // ── 1. Immediately remove source elements from DOM ──
        $.each(itemSnapshots, (index, snap) => {
            snap.ivItem.remove();
        });

        // ── 2. Update source data model (remove from canonical parent.childs & dataNode) ──
        $.each(itemSnapshots, (index, snap) => {
            const itemData = snap.itemData || snap.item.data('data');
            if (!itemData) return;

            const sourceParentId = itemData.parent ? itemData.parent.id : null;
            const parentObj = sourceParentId ? myself.findItemById(sourceParentId) : (itemData.parent || myself.dataNodeParent);

            if (parentObj && Array.isArray(parentObj.childs)) {
                const idx = parentObj.childs.findIndex(c => c && c.id == itemData.id);
                if (idx !== -1) parentObj.childs.splice(idx, 1);
            }

            if (Array.isArray(myself.dataNode)) {
                const idx = myself.dataNode.findIndex(c => c && c.id == itemData.id);
                if (idx !== -1) myself.dataNode.splice(idx, 1);
            }
        });

        myself.refreshTree();

        // ── 3. Send AJAX ──
        ajaxForm({
            url: request,
            method: 'POST',
            data,
            callback(resData, form) {
                const resDataObj = (resData && resData.meta) ? resData.meta : (resData && resData.data ? resData.data : {});

                // Update each item in the data model using its snapshot merged with resData
                $.each(itemSnapshots, (index, snap) => {
                    const originalItemData = snap.itemData || {};
                    const updatedItem = Object.assign({}, originalItemData, resDataObj);

                    if (!updatedItem.type && originalItemData.type) {
                        updatedItem.type = originalItemData.type;
                    }
                    if (!updatedItem.label && resDataObj.item && resDataObj.item.name) {
                        updatedItem.label = resDataObj.item.name;
                    } else if (!updatedItem.label && originalItemData.label) {
                        updatedItem.label = originalItemData.label;
                    }
                    if (resDataObj.id) {
                        updatedItem.id = resDataObj.id;
                    }

                    if (isRootTarget) {
                        // Target is root: add to myself.data
                        const rootArr = myself.data;
                        if (Array.isArray(rootArr)) {
                            const existingIdx = rootArr.findIndex(c => c && c.id == updatedItem.id);
                            if (existingIdx !== -1) rootArr[existingIdx] = updatedItem;
                            else rootArr.push(updatedItem);
                        }
                        myself.prepareData(myself.data, { childs: myself.data, type: 'root' }, []);
                    } else {
                        // Target is a child container: find canonical object in myself.data
                        const destObj = myself.findItemById(resolvedNewParentId);
                        if (destObj) {
                            if (!Array.isArray(destObj.childs)) destObj.childs = [];
                            const existingIdx = destObj.childs.findIndex(c => c && c.id == updatedItem.id);
                            if (existingIdx !== -1) destObj.childs[existingIdx] = updatedItem;
                            else destObj.childs.push(updatedItem);

                            myself.prepareData(destObj.childs, destObj, destObj.path || []);
                        }
                    }
                });

                // Always reload the current path data and re-render the view
                myself.loadPath(myself.path, true);
                myself.render();
            },
        });
    };





IconsView.prototype.submitChange = function (item, data) {
        if (item) {
            const myself = this;
            let { api } = item;
            data.id = item.id;
            if (!api && myself.options.api) api = myself.options.api[item.type];

            data = [data];
            ajaxForm({
                url: api,
                method: 'POST',
                data: data,
                callback(data, form) {
                    myself.quickLoad(item, data);
                },
            });
        }
    };


IconsView.prototype.submitDelete = function (item) {
        if (item) {
            const myself = this;
            let { api } = item;
            data.id = item.id;
            if (!api && myself.options.api) api = myself.options.api[item.type];

            ajaxForm({
                url: api,
                method: 'DELETE',
                callback(data, form) {
                    item.remove();
                    // myself.quickLoad(item);
                },
            });
        }
    };


IconsView.prototype.remove = function (item) {
        const myself = this;
        let el = $(item);
        if (!el.hasClass('iv__item')) {
            el = el.closest('.iv__item');
        }
        const items = el.parent().find('.iv__item').not(el);
        const dataClean = [];
        for (let i = 0; i < items.length; i++) {
            const d = $(items[i]).data('data');
            const clean = (d && d.dataClean !== undefined) ? d.dataClean : d;
            if (clean !== undefined && clean !== null) {
                dataClean.push(clean);
            }
        }
        this.dataClean = dataClean;
        this.dataJsonCache = null;
        this.save();
        this.quickLoad();
        if (this.events.edit) this.events.edit();
    };


IconsView.prototype.add = function (data) {
        const myself = this;
        // remove empty line
        $.each(this.dataNode, (index, data) => {
            if (data && data.special == 'none') {
                myself.dataNode.splice(index, 1);
            }
        });

        this.dataNode.push(clone(data));
        this.dataClean.push(clone(data));
        this.render();
        if (this.events.edit) this.events.edit();
        this.save();
    }


IconsView.prototype.exportData = function () {
        const output = [];
        $.each(this.dataNode, (index, data) => {
            if (data) {
                output.push(data);
            }
        });
        return output;
    }


IconsView.prototype.testPngAlpha = function ($icon) {
        if (this.cachePng[$icon] === false || this.cachePng[$icon] === true) return this.cachePng[$icon];

        const filestream = load_binary_resource($icon);
        const test = filestream.charCodeAt(25) & 0xff;
        this.cachePng[$icon] = false;
        if (test == 6) {
            this.cachePng[$icon] = true;
        }
        return this.cachePng[$icon];
    }


IconsView.prototype.setCursor = function(cursor) {
        if (cursor != this.cursor && cursor != this.cursorLast && cursor != 'last') {
            this.cursorLast = this.cursor;
        }

        $('body').removeClass(function(index, className) {
            return (className.match(/(^|\s)cursor--\S+/g) || []).join(' ');
        });
        if (cursor == 'last') {
            cursor = this.cursorLast
        }
        if (cursor) {
            $('body').addClass('cursor--' + cursor);
        }
        this.cursor = cursor;
    }


    // Public Convenience API (non-breaking helpers)
    IconsView.prototype.getSelection = function () {
        return this.selection ? [].concat(this.selection) : [];
    };

    IconsView.prototype.clearSelection = function () {
        this.selection = [];
        const grid = this.element.hasClass('iconGrid') ? this.element : this.element.find('.iconGrid').addBack('.iconGrid');
        grid.find('.iv__item--selected').removeClass('iv__item--selected');
        this.changeSelection();
        return this;
    };

    IconsView.prototype.getData = function () {
        return this.data;
    };

    IconsView.prototype.setBusy = function (state) {
        this.isBusy = !!state;
        return this;
    };

    IconsView.prototype.reload = function () {
        this.load();
        return this;
    };

    IconsView.prototype.refresh = function () {
        this.render();
        return this;
    };


}
